import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Lock } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { eur } from "@/lib/api";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();
  const soldOut = product.in_stock === false;

  const handleAdd = (e) => {
    e.preventDefault();
    if (soldOut) return;
    if (!user) { nav("/entrar", { state: { from: "/loja" } }); return; }
    add(product, 1);
  };

  return (
    <div className="product-card group relative" data-testid={`product-card-${product.id}`}>
      <Link to={`/produto/${product.id}`} className="block">
        <div className="product-card-img aspect-[4/5] mb-4 relative">
          <img src={product.image_url} alt={product.name} loading="lazy" className={soldOut ? "opacity-60" : ""} />
          {soldOut && (
            <span className="absolute top-3 left-3 bg-[#2C2A28] text-white text-[10px] uppercase tracking-wider px-2 py-1" data-testid={`sold-out-badge-${product.id}`}>
              Esgotado
            </span>
          )}
        </div>
      </Link>
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <Link to={`/produto/${product.id}`}>
            <h3 className="font-serif text-xl brand-text truncate" data-testid={`product-name-${product.id}`}>{product.name}</h3>
          </Link>
          <p className="text-xs brand-muted mt-1 uppercase tracking-wider">{product.category}</p>
          {user ? (
            <p className="text-sm brand-text mt-2" data-testid={`product-price-${product.id}`}>{eur(product.price)}</p>
          ) : (
            <Link
              to="/entrar"
              state={{ from: "/loja" }}
              className="text-xs brand-primary-text mt-2 inline-block underline hover:opacity-80"
              data-testid={`product-price-locked-${product.id}`}
            >
              Entrar para ver preço
            </Link>
          )}
        </div>
        <button
          onClick={handleAdd}
          disabled={soldOut}
          className={`opacity-0 group-hover:opacity-100 transition p-3 rounded-sm ${soldOut ? "bg-gray-300 cursor-not-allowed" : "brand-primary"}`}
          aria-label={soldOut ? "Esgotado" : user ? "Adicionar ao carrinho" : "Entrar para comprar"}
          title={soldOut ? "Esgotado" : user ? "Adicionar ao carrinho" : "Entrar para comprar"}
          data-testid={`btn-add-${product.id}`}
        >
          {soldOut ? <Lock size={16} /> : user ? <ShoppingBag size={16} /> : <Lock size={16} />}
        </button>
      </div>
    </div>
  );
}
